import { Fancybox } from '@fancyapps/ui';


$(document).ready(function () {
    var $root = $('html, body');
    var isIE = /MSIE|Trident/.test(window.navigator.userAgent);

    // fix missing forEach on NodeList for IE11
    if (isIE) {
        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = Array.prototype.forEach;
        }
    }


    // Featured Nav
    function openFeaturedNavDropdown() {
        $('#featured-nav-dropdown-toggle').addClass('open');
        $('#featured-nav-dropdown').addClass('open');
        $('#menu-underlay').addClass('active');
    }
    function closeFeaturedNavDropdown() {
        $('#featured-nav-dropdown-toggle').removeClass('open');
        $('#featured-nav-dropdown').removeClass('open');
        $('#menu-underlay').removeClass('active');
    }

    if ($('#featured-nav-dropdown').length !== 0) {

        // Hover over link to open dropdown
        $('#featured-nav-dropdown-toggle').on('mouseenter', function () {
            openFeaturedNavDropdown();
        });
        $('#featured-nav-dropdown').on('mouseleave', function () {
            if (!$('#featured-nav-dropdown-toggle').hasClass('stay-open')) {
                closeFeaturedNavDropdown();
            }
        });

        // Click on link to keep dropdown open, click again to close it 
        $('#featured-nav-dropdown-toggle').on('click', function () {
            if (!$(this).hasClass('stay-open')) {
                openFeaturedNavDropdown();
                $(this).addClass('stay-open');
            } else {
                closeFeaturedNavDropdown();
                $(this).removeClass('stay-open');
            }
        });

        // Close dropdown on menu underlay click
        $('#menu-underlay').on('click', function () {
            $('#featured-nav-dropdown-toggle').removeClass('stay-open');
            closeFeaturedNavDropdown();
        })
    }

    // Burger Nav (Main Nav)
    if ($('.burger-toggle').length !== 0 && $('#burger-menu').length !== 0) {
        $('.burger-toggle').on('click', function () {
            $(this).toggleClass('burger-toggle-open');
            $('#burger-menu').toggleClass('open');
            $('#page-header').toggleClass('burger-menu-open');

            // ensure featured nav is closed
            closeFeaturedNavDropdown();
        });
    }

    // Featured and Burger nav close using escape key
    document.onkeydown = function (e) {
        e = e || window.event;
        if (e.keyCode == 27) {
            closeFeaturedNavDropdown();
            $('.burger-toggle').removeClass('burger-toggle-open');
            $('#burger-menu').removeClass('open');
            $('#page-header').removeClass('burger-menu-open');
        }
    };

    // Browse menu top corner colour
    if ($('#browse').find('.browse-menu').length !== 0) {
        let firstLink = $('#browse').find('.browse-menu li:first-child a');
        let browseSection = $('#browse').find('.browse-section');
        if ($(firstLink).hasClass('current-page')) {
            $(browseSection).addClass('first-item-active');
        } else {
            $(firstLink).hover(function () {
                $(browseSection).addClass('first-item-active');
            }, function () {
                $(browseSection).removeClass('first-item-active');
            });
        }
    }

    // convert svg image to inline svg (doesn't work in IE)
    if (!isIE) {
        if ($('img.inline-svg').length !== 0) {
            const convertImages = function (query, callback) {
                const images = document.querySelectorAll(query);

                images.forEach(function (image) {
                    fetch(image.src)
                        .then(function (res) { return res.text() })
                        .then(function (data) {
                            const parser = new DOMParser();
                            const svg = parser.parseFromString(data, 'image/svg+xml').querySelector('svg');

                            if (image.id) svg.id = image.id;
                            if (image.className) svg.classList = image.classList;
                            if (image.title) svg.title = image.title;

                            if (image.parentNode) image.parentNode.replaceChild(svg, image);
                        })
                        .then(callback)
                });
            }
            convertImages('img.inline-svg');
        }
    }




    // Scroll to ID (doesn't work in IE)
    if (!isIE) {
        document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();
                if ($('[name="' + $.attr(this, 'href').substr(1) + '"]') !== null && $('[name="' + $.attr(this, 'href').substr(1) + '"]').length !== 0) {
                    // scroll to name (75px page header, 60px margin)
                    $root.animate({
                        scrollTop: $('[name="' + $.attr(this, 'href').substr(1) + '"]').offset().top - 75 - 60
                    }, 300);
                    return false;
                }
            });
        });
    }

    // Anchor Link Offset
    $(window).on('load', function () {
        if (location.hash.length !== 0) {
            var target = location.hash.replace('#', '');
            if ($('[name="' + target + '"]')[0]) {
                // scroll to name (75px page header, 60px margin)
                $root.animate({
                    scrollTop: $('[name="' + target + '"]').offset().top - 75 - 60
                }, 300);
            } else if ($('[id="' + target + '"]')[0]) {
                // scroll to id (75px page header, 60px margin)
                $root.animate({
                    scrollTop: $('[id="' + target + '"]').offset().top - 75 - 60
                }, 300);
            }
        }

    });



    $(".article-card").slice(0, 12).show();

    if ($(".article-card:hidden").length == 0) {
        $("#load-more").remove();
    }

    $("#load-more").on('click', function (e) {
        e.preventDefault();
        $(".article-card:hidden").slice(0, 12).show();
        if ($(".article-card:hidden").length == 0) {
            $("#load-more").remove();
        }
    });

    function keyPress(e) {
        if (e.key === "Escape") { // escape key maps to keycode `27`
            $('#user-feedback-toggle').trigger('click');
            $(document).unbind("keyup", keyPress);
        }
    }

    // User feedback toggle
    $('#user-feedback-toggle').on('click', function () {
        $('#user-feedback').toggleClass('open');
        $(document).keyup(keyPress);
    });

    // User feedback hide on mobile when scrolling down
    if (window.innerWidth < 768 && $('#user-feedback').length !== 0) {
        var lastScrollTop = 0;
        $(window).scroll(function () {
            if (!$('#user-feedback').hasClass('open')) {
                var st = $(this).scrollTop();
                setTimeout(function () {
                    if (st > lastScrollTop + 5) {
                        // downscroll code
                        $('#user-feedback').addClass('hidden');
                    } else if (st < lastScrollTop - 15) {
                        // upscroll code
                        $('#user-feedback').removeClass('hidden');
                    }
                    lastScrollTop = st;
                }, 150);
            }
        });
    }

    // page refresh
    $('#location-reload').on('click', function () {
        window.history.replaceState(null, null, window.location.pathname);
        location.reload();
    });

    // Add rel="noopener" to external links for security
    function noopenerToExternalLinks() {
        $('a[href^="http"]').not('a[href*="' + location.hostname + '"]').attr({ target: "_blank", rel: "noopener" });
    }
    noopenerToExternalLinks();

    addQueryStringToUrl();

    showSiteSearchResult();


    waitUntilElementExist('.card', (element) => {
        matchCardHeights();
    }, 50, 3000); // Check every 50ms, timeout after 3 seconds
}); // End $(document).ready

// Onload
window.onload = function () {

    // Mailchimp user feedback form - iframe src
    if ($('#user-feedback-form-iframe').length !== 0) {
        setTimeout(function () {
            document.getElementById('user-feedback-form-iframe').src = 'https://us6.list-manage.com/survey?u=ef741df6f3215cebd8c693760&id=66060bb7d3';
        }, 1000);
    }

} // end window.onload

// Match card height
function matchCardHeights() {
    if (window.innerWidth >= 992) {
        $('.cards:not(.no-match-card-height)').each(function () {
            const heights = [];
            $('.card', this).each(function () {
                heights.push($(this).outerHeight());
            })
            const tallestCardHeight = Math.max.apply(Math, heights);
            $('.card', this).css('min-height', tallestCardHeight);
        });

        //Fixes home page latest articles
        const latestArticlesCardheights = [];
        const cards = document.querySelectorAll('.card');
        cards.forEach(function (card) {
            latestArticlesCardheights.push(card.offsetHeight);
        });
        const latestArticlesTallestCardHeight = Math.max(...latestArticlesCardheights);
        cards.forEach(function (card) {
            card.style.minHeight = latestArticlesTallestCardHeight + 'px';
        });
    }
}

function siteSearchCallBack() {
    showSiteSearchResult();
    //matchCardHeights();
    addQueryStringToUrl();
}

function addQueryStringToUrl() {
    $("#query-string-search").submit(function () {
        var form = $(this).closest('form');
        var queryData = form.serialize().toLowerCase();
        history.pushState("", "", "?" + queryData);
    })
}



function showSiteSearchResult() {
    if ($("#site-search-text").val()) {
        $("#section-search-form").removeClass("before-search-submit");
    }

    $(".resource-card").slice(0, 4).show();
    $(".news-card").slice(0, 4).show();
    $(".document-card").slice(0, 4).show();
    $(".page-card").slice(0, 4).show();
    $(".archived-card").slice(0, 4).show();

    if ($(".resource-card:hidden").length == 0) {
        $("#resource-loadmore").remove();
    }

    if ($(".news-card:hidden").length == 0) {
        $("#news-loadmore").remove();
    }

    if ($(".document-card:hidden").length == 0) {
        $("#document-loadmore").remove();
    }

    if ($(".page-card:hidden").length == 0) {
        $("#page-loadmore").remove();
    }

    if ($(".archived-card:hidden").length == 0) {
        $("#archived-loadmore").remove();
    }

    $("#resource-loadmore").on('click', function (e) {
        e.preventDefault();
        $(".resource-card:hidden").slice(0, 12).show();
        matchCardHeights();
        if ($(".resource-card:hidden").length == 0) {
            $("#resource-loadmore").remove();
        }
    });

    $("#document-loadmore").on('click', function (e) {
        e.preventDefault();
        $(".document-card:hidden").slice(0, 12).show();
        matchCardHeights();
        if ($(".document-card:hidden").length == 0) {
            $("#document-loadmore").remove();
        }
    });

    $("#news-loadmore").on('click', function (e) {
        e.preventDefault();
        $(".news-card:hidden").slice(0, 12).show();
        matchCardHeights();
        if ($(".news-card:hidden").length == 0) {
            $("#news-loadmore").remove();
        }
    });

    $("#page-loadmore").on('click', function (e) {
        e.preventDefault();
        $(".page-card:hidden").slice(0, 12).show();
        matchCardHeights();
        if ($(".page-card:hidden").length == 0) {
            $("#page-loadmore").remove();
        }
    });

    $("#archived-loadmore").on('click', function (e) {
        e.preventDefault();
        $(".archived-card:hidden").slice(0, 12).show();
        matchCardHeights();
        if ($(".archived-card:hidden").length == 0) {
            $("#archived-loadmore").remove();
        }
    });
}

// SKIP TO CONTENT
var initialLoad = true;
var tabIndex = 0;

$(document).ready(function () {
    $(document).on('keyup', function (e) {
        if (e.which === 9) {
            if (tabIndex === 0 && window.scrollY === 0 && initialLoad) {
                $(this).blur();
                e.preventDefault();
                $('#screen-reader-skip').addClass('active');
                $('#screen-reader-skip').focus();
                tabIndex++;
            } else {
                $('#screen-reader-skip').removeClass('active');
            }

            initialLoad = false;
        }
    });

    $('#screen-reader-skip').on('keyup click', function (e) {
        $($("[name='screen-reader-scroll-point']").find('a')[0]).focus();
        $('#screen-reader-skip').removeClass('active');
        tabIndex = 0;
    });

    $('#screen-reader-skip').blur(function () {
        $('#screen-reader-skip').removeClass('active');
    });

    $('.header-search-button').on('click', function () {
        $('#popup-search .search-modal__form-input').val('')
        $('.search-modal__popular').show();
        window.displayRecentSearchesBlock();
        setTimeout(() => {
            $('.modal-close-button').on('click', function () {
                if ($('.search-modal__results-filter').length > 0) {
                    $('.search-modal__popular').hide();
                }

            })
        }, 500);

    })

    /* ==========================================================================
       Mobile Menu Button
       ========================================================================== */

    const navButton = document.querySelector(".js-trigger-mobile-nav");
    const navElement = document.querySelector(".main-nav");

    navButton.addEventListener("click", function () {
        navElement.classList.toggle("is-active");
        this.classList.toggle("is-active");
    });

    // Close mobile menu when navigating to an anchor on the current page
    document.querySelectorAll('[data-section-link="true"]').forEach(function (link) {
        link.addEventListener('click', function () {
            navElement.classList.remove("is-active");
            navButton.classList.remove("is-active");
        });
    });

    /* ==========================================================================
       Sub nav
       ========================================================================== */

    document.querySelectorAll('.js-toggle-subnav').forEach(function (e, i) {
        e.addEventListener('click', function (event) {
            event.preventDefault();
            this.classList.toggle("is-active");
            this.nextElementSibling.classList.toggle("is-active");
            document.querySelectorAll('.js-toggle-subnav').forEach((e) => {
                if (e !== this) {
                    e.classList.remove("is-active");
                    e.nextElementSibling.classList.remove("is-active");
                }
            });
        });
    });

    document.querySelectorAll('.js-close-subnav').forEach(function (e, i) {
        e.addEventListener('click', function (event) {
            event.preventDefault();
            //document.querySelectorAll('.sub-nav').classList.remove("is-active");
            this.closest('.sub-nav').classList.remove("is-active");
        });
    });

    /* ==========================================================================
       Careers nav - section highlighting (scroll-spy)

       Careers nav items whose link is an on-page anchor (a job section) are
       flagged with data-section-link. As the user scrolls, highlight the nav
       item for the section currently in view by toggling aria-current / is-current.
       ========================================================================== */

    (function initCareersSectionSpy() {
        var sectionLinks = Array.prototype.slice.call(
            document.querySelectorAll('.main-nav--careers a[data-section-link]')
        );

        if (sectionLinks.length === 0) {
            return;
        }

        var header = document.querySelector('.header');

        // Map each nav link to its target section element on the page.
        var spyItems = sectionLinks.map(function (link) {
            var href = link.getAttribute('href') || '';
            var hashIndex = href.indexOf('#');
            var id = hashIndex >= 0 ? href.substring(hashIndex + 1) : '';
            if (!id) {
                return null;
            }
            var target = document.querySelector('[name="' + id + '"], #' + CSS.escape(id));
            return target ? { link: link, target: target } : null;
        }).filter(Boolean);

        if (spyItems.length === 0) {
            return;
        }

        function setActive(activeLink) {
            spyItems.forEach(function (item) {
                var isActive = item.link === activeLink;
                item.link.classList.toggle('is-current', isActive);
                if (isActive) {
                    item.link.setAttribute('aria-current', 'page');
                } else {
                    item.link.removeAttribute('aria-current');
                }
            });
        }

        var ticking = false;

        function updateActiveSection() {
            ticking = false;

            // Trigger point just below the sticky header.
            var offset = (header ? header.offsetHeight : 0) + 80;
            var current = null;

            spyItems.forEach(function (item) {
                var top = item.target.getBoundingClientRect().top;
                if (top - offset <= 0) {
                    current = item.link;
                }
            });

            // Near the bottom of the page, force the last section active so the
            // final section can be reached even if it is short.
            if ((window.innerHeight + window.scrollY) >= (document.body.scrollHeight - 2)) {
                current = spyItems[spyItems.length - 1].link;
            }

            setActive(current);
        }

        function onScroll() {
            if (!ticking) {
                window.requestAnimationFrame(updateActiveSection);
                ticking = true;
            }
        }

        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        updateActiveSection();
    })();

    /* ==========================================================================
       Hero News Slider
       ========================================================================== */


    $('.js-hero-news-slider').slick({
        infinite: false,
        dots: false,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true,
                }
            },
            {
                breakpoint: 577,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                }
            },
        ]
    });

    /* ==========================================================================
       Hero Banner Slider
       ========================================================================== */

    $('.js-hero-banner-slider').slick({
        fade: true,
        infinite: true,
        dots: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
    });

    /* ==========================================================================
       CTA Links Toggle
       ========================================================================== */

    document.querySelectorAll('.js-toggle-cta-item').forEach(function (e, i) {
        e.addEventListener('click', function (event) {
            event.preventDefault();
            this.classList.toggle("is-active");
            var targetModal = this.getAttribute('aria-controls');
            document.getElementById(targetModal).classList.add("is-active");
            document.querySelectorAll('.js-toggle-cta-item').forEach((e) => {
                if (e !== this) {
                    e.classList.remove("is-active");
                }
            });
            document.querySelectorAll('.cta-links-block__content-item').forEach((e) => {
                if (e !== document.getElementById(targetModal)) {
                    e.classList.remove("is-active");
                }
            });
        });
    });
});

/* ==========================================================================
   Campaign Case Study Slider (Overlaying Cards Block)
   ========================================================================== */

var campaignCaseStudySliderSettings = {
    infinite: false,
    dots: false,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '<button class="slick-prev slick-arrow"><span class="screen-reader-text">Previous slide</span> <svg class="icon" role="presentation" id="slick-prev-icon"><use xlink:href="#icon-campaign-arrow-left"></use></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow"><span class="screen-reader-text">Next slide</span> <svg class="icon" role="presentation" id="slick-next-icon"><use xlink:href="#icon-campaign-arrow-right"></use></svg></button>',
    responsive: [{
            breakpoint: 1025,
            settings: {
                arrows: true
            }
        }, {
            breakpoint: 769,
            settings: {
                slidesToShow: 2.5,
                slidesToScroll: 1,
                arrows: true
            }
        },
        {
            breakpoint: 577,
            settings: {
                slidesToShow: 1.5,
                slidesToScroll: 1,
                arrows: true
            }
        },
    ]
};

function initCampaignCaseStudySlider($slider) {
    if (!$slider.length) {
        return;
    }

    $slider.each(function () {
        var $this = $(this);

        if ($this.hasClass('slick-initialized')) {
            $this.slick('setPosition');
            return;
        }

        $this.slick(campaignCaseStudySliderSettings);
    });
}

initCampaignCaseStudySlider($('.js-campaign-case-study-slider').not('.js-case-study-modal .js-campaign-case-study-slider'));

var defaultCloseIcon = document.body.classList.contains('careers-template') ? 'icon-campaign-cross' : 'icon-close';

Fancybox.bind('[data-fancybox]', {
    tpl: {
        closeButton: '<button data-fancybox-close class="is-close-btn modal-close-button" title="{{CLOSE}}"><svg class="icon" role="presentation"><use xlink:href="#' + defaultCloseIcon + '"></use></svg></button>',
    }
});

Fancybox.bind('[data-fancybox].js-principles-learn-more', {
    tpl: {
        closeButton: '<button data-fancybox-close class="is-close-btn modal-close-button" title="{{CLOSE}}"><svg class="icon" role="presentation"><use xlink:href="#icon-campaign-cross"></use></svg></button>',
    }
});

Fancybox.bind('[data-fancybox].js-case-study-learn-more', {
    dragToClose: false,
    Carousel: {
        Panzoom: {
            touch: false
        }
    },
    tpl: {
        closeButton: '<button data-fancybox-close class="is-close-btn modal-close-button" title="{{CLOSE}}"><svg class="icon" role="presentation"><use xlink:href="#icon-campaign-cross"></use></svg></button>',
    },
    on: {
        done: function (fancybox) {
            window.setTimeout(function () {
                var slide = fancybox.getSlide();

                if (!slide || !slide.el) {
                    return;
                }

                initCampaignCaseStudySlider($(slide.el).find('.js-campaign-case-study-slider'));
            }, 0);
        }
    }
});

/* ==========================================================================
   Campaign Case Study tile toggle
   ========================================================================== */
document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.js-toggle-case-study-tile');

    if (!toggle) {
        return;
    }

    event.preventDefault();

    var tile = toggle.closest('.campaign-case-study__tile');

    if (tile) {
        tile.classList.toggle('is-active');
    }
});

function waitUntilElementExist(selector, callback, interval = 100, timeout = 5000) {
    let checkInterval;
    let elapsedTime = 0;

    const checkElement = () => {
        const element = document.querySelector(selector); // Attempts to find the element

        if (element) {
            // If the element is found:
            callback(element);         // Execute the provided callback function
            clearInterval(checkInterval); // Crucially, stop the interval from running further
        } else if (elapsedTime >= timeout) {
            // If the timeout is reached and the element is still not found:
            clearInterval(checkInterval); // Stop the interval

        } else {
            // If the element is not yet found and timeout hasn't been reached:
            elapsedTime += interval; // Increment the elapsed time
        }
    };
    // It calls the checkElement function every interval milliseconds.
    checkInterval = setInterval(checkElement, interval);
}


/* ==========================================================================
   Hero Video Toggle
   ========================================================================== */

const videoIframe = document.getElementById("vimeoPlayer");
const videoButton = document.getElementById("togglePlay");
if (videoIframe != undefined && videoButton != undefined) {
    const isYouTube = videoIframe.dataset.videoProvider === "youtube";

    const post = (message) => videoIframe.contentWindow.postMessage(JSON.stringify(message), "*");

    const sendCommand = (action) => {
        if (isYouTube) {
            post({ event: "listening" });
            post({ event: "command", func: action === "play" ? "playVideo" : "pauseVideo", args: [] });
        } else {
            post({ method: action });
        }
    };

    let isPlaying = true;

    videoButton.addEventListener("click", () => {
        sendCommand(isPlaying ? "pause" : "play");
        videoButton.textContent = isPlaying ? "Play video" : "Pause video";
        isPlaying = !isPlaying;
    });
}

/* ==========================================================================
   Campaign Navigation Scroll Buttons
   ========================================================================== */

document.querySelectorAll('.campaign-nav').forEach(function(navSection) {
    var navContainer = navSection.querySelector('.campaign-nav__navigation');
    var prevBtn = navSection.querySelector('.campaign-nav__arrow-button--prev');
    var nextBtn = navSection.querySelector('.campaign-nav__arrow-button--next');

    if (!navContainer) {
        return;
    }

    function updateArrowButtons() {
        var scrollLeft = navContainer.scrollLeft;
        var maxScrollLeft = navContainer.scrollWidth - navContainer.clientWidth;

        var isAtLeft = scrollLeft <= 2;
        var isAtRight = maxScrollLeft <= 0 || scrollLeft >= maxScrollLeft - 2;

        if (prevBtn) {
            prevBtn.disabled = isAtLeft;
            prevBtn.setAttribute('aria-disabled', isAtLeft ? 'true' : 'false');
            prevBtn.classList.toggle('is-disabled', isAtLeft);
        }

        if (nextBtn) {
            nextBtn.disabled = isAtRight;
            nextBtn.setAttribute('aria-disabled', isAtRight ? 'true' : 'false');
            nextBtn.classList.toggle('is-disabled', isAtRight);
        }
    }

    if (prevBtn) {
        prevBtn.addEventListener('click', function(event) {
            event.preventDefault();
            var scrollAmount = Math.max(navContainer.clientWidth * 0.6, 200);
            navContainer.scrollBy({
                left: -scrollAmount,
                behavior: 'smooth'
            });
        });
    }

    if (nextBtn) {
        nextBtn.addEventListener('click', function(event) {
            event.preventDefault();
            var scrollAmount = Math.max(navContainer.clientWidth * 0.6, 200);
            navContainer.scrollBy({
                left: scrollAmount,
                behavior: 'smooth'
            });
        });
    }

    navContainer.addEventListener('scroll', updateArrowButtons);
    window.addEventListener('resize', updateArrowButtons);

    updateArrowButtons();
});